<p-dialog [(visible)]="showCamDialogue" [draggable]="false" (onHide)="closeDialogue()" class="p-button-text"
    [resizable]="false" [blockScroll]=true [modal]=true style="background-color: #BA141A; border: none;">
    <p-header class="row modal-header">
        <h5 class="modal-title">
            <b> {{ picMetaData?.picTitle }}</b>
        </h5>
    </p-header>
    <div class="modal-body col-sm-12" style=" padding-top: 10px;">
        <div *ngIf="isCameraExist; else noCameraExist">
            <div style="text-align:center;" class="col-sm-12">
                <div class="btn-group">
                    <button type="button" class="btn-camera" (click)="takeSnapshot()" style="border-radius: 5px;">Take
                        Picture</button>

                    &nbsp; <button type="button" class="btn-camera" (click)="onOffWebCame()"
                        style="border-radius: 5px;">Switch camera</button>
                </div>
            </div>
            &nbsp; &nbsp;
            <div class="col-sm-12" style="text-align: center;">
                <webcam [height]="300" [width]="300" [trigger]="triggerObservable" (imageCapture)="handleImage($event)"
                    *ngIf="switchOnWebcam" [switchCamera]="nextWebcamObservable"></webcam>
            </div>
            <div *ngIf="errors.length > 0">
                <h4>Error Messages:</h4>
                <ul *ngFor="let error of errors">
                    <li>{{ error | json }}</li>
                </ul>
            </div>
        </div>

        <ng-template #noCameraExist>
            Camera device not available
        </ng-template>
        <div class="row">
            <div class="col-sm-12 webcam-image " *ngIf="webcamImage">
                <img class="webcam-image" [src]="webcamImage.imageAsDataUrl" width="300" height="240" />
            </div>
        </div>
    </div>
</p-dialog>